/**
 * States of an offer as defined by the ERP. Mirrors
 * Blexon.ERPServiceAPI.Interfaces.OfferService.OfferState, including its numeric
 * values, because they are persisted as integers.
 */
export enum OfferState {
	/** Submitted by the customer, Blexon has not made an offer yet. */
	WaitingForManualOffer = 0,
	/** An offer is available and Blexon is waiting for the customer. */
	WaitingForCustomerAnswer = 1,
	/** The customer accepted the offer, an order exists now. */
	Accepted = 2,
	/** The customer declined the offer. */
	Declined = 3,
	/** The customer started the request but has not submitted it yet. */
	Draft = 4,
}
